export const handleDropdownVisibleChange = (visible, selectRef) => {
  try {
    if (visible) {
      setTimeout(() => {
        const dropdownNodes = document.querySelectorAll(".ant-select-dropdown");
        dropdownNodes.forEach((dropdown) => {
          dropdown.style.position = "fixed";

          if (selectRef && selectRef.$el) {
            const triggerRect = selectRef.$el.getBoundingClientRect();
            const dropdownRect = dropdown.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;

            let top = triggerRect.bottom;
            let left = triggerRect.left;

            if (triggerRect.bottom + dropdownRect.height > viewportHeight) {
              top = triggerRect.top - dropdownRect.height;
            }

            if (triggerRect.left + dropdownRect.width > viewportWidth) {
              left = triggerRect.right - dropdownRect.width;
            }

            dropdown.style.top = `${top}px`;
            dropdown.style.left = `${left}px`;
            dropdown.style.zIndex = "1050";
          }
        });
      }, 0);
    }
  } catch (error) {
    console.error(
      "An error occurred while handling dropdown visible change: ",
      error,
    );
  }
};

export const handleResize = () => {
  try {
    const dropdowns = document.querySelectorAll(".ant-select-dropdown");
    if (dropdowns.length > 0) {
      handleDropdownVisibleChange(true);
    }
  } catch (error) {
    console.error("An error occurred while handling resize: ", error);
  }
};

export const filterOption = (input, option) => {
  try {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  } catch (error) {
    console.error("An error occurred while filtering options: ", error);
  }
};

export const sortOptionsSelectedFirst = (options, isSelectedFn) => {
  if (!options || options.length === 0) {
    return { sortedOptions: [], selectedCount: 0 };
  }

  const selected = [];
  const unselected = [];

  for (const option of options) {
    if (isSelectedFn(option)) {
      selected.push(option);
    } else {
      unselected.push(option);
    }
  }

  return {
    sortedOptions: [...selected, ...unselected],
    selectedCount: selected.length,
  };
};
